const makeDealUpdate = (updatePayload) => {
    var allowedUpdates = {}
    updatePayload.dealId?allowedUpdates.dealId=updatePayload.dealId: void 0;
    updatePayload.status?allowedUpdates.status=updatePayload.status: void 0;
    updatePayload.visibility?allowedUpdates.visibility=updatePayload.visibility: void 0;

    

    if(!allowedUpdates.dealId) throw "deal update requires valid dealId"
    else return allowedUpdates
}

export {makeDealUpdate}
  


// WEBPACK FOOTER //
// ./src/platform/deals/services/transformer/dealExportTransformer.js